import { useQuery } from '@apollo/react-hooks';
import qs from 'qs';
import { utils, graphql, PatientLabResponseData } from 'kb-shared';

const OB_VISIT_URL_PARAMS = qs.stringify({
  step: 'location',
  // eslint-disable-next-line @typescript-eslint/camelcase
  appointment_id: utils.appointmentTypes(process.env.REACT_APP_ENV).NEW_OB_VISIT
});

const useRiskAssessmentResult = hasRisk => {
  const { PATIENT_LAB } = graphql.query;
  const { data } = useQuery<PatientLabResponseData>(PATIENT_LAB);
  const isDisneyPatient = utils.isDisneyPatient(
    process.env.REACT_APP_ENV,
    String(data?.patientLab?.lab.id)
  );
  const bookOBVisitURL = isDisneyPatient ? `/Book?${OB_VISIT_URL_PARAMS}` : undefined;

  const RISK_OB_VISIT_INSTRUCTIONS_COPY =
    'If you have already booked your first pregnancy appointment, there is nothing you need to do. Otherwise, please schedule a visit with your OBGYN provider within the next 10 days.';
  const OB_VISIT_INSTRUCTIONS_COPY =
    'If you have already booked your first pregnancy appointment, there is nothing you need to do. Otherwise, please schedule a visit with your OBGYN provider within your first 6-8 weeks of pregnancy.';
  const RISK_INSTRUCTIONS_COPY =
    'If you have already booked your first pregnancy appointment, there is nothing you need to do. Otherwise, please schedule a visit with your OBGYN provider within the next 10 days.';
  const INSTRUCTIONS_COPY =
    'If you have already booked your first pregnancy appointment, there is nothing you need to do. Otherwise, please schedule a visit with your OBGYN provider within your first 6-8 weeks of pregnancy.';

  let instructionsCopy;

  if (hasRisk && bookOBVisitURL) {
    instructionsCopy = RISK_OB_VISIT_INSTRUCTIONS_COPY;
  } else if (!hasRisk && bookOBVisitURL) {
    instructionsCopy = OB_VISIT_INSTRUCTIONS_COPY;
  } else if (hasRisk) {
    instructionsCopy = RISK_INSTRUCTIONS_COPY;
  } else {
    instructionsCopy = INSTRUCTIONS_COPY;
  }

  return { bookOBVisitURL, instructionsCopy };
};

export default useRiskAssessmentResult;
